/**
 * The image of the camera view
 * Rendered in ImageDetails.js
 */

import React from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setCamera } from '../dashboard/EventMedia/actions';
import { CameraType } from '../../../data/media';

import LiveMediaImage from '../dashboard/LiveMedia/LiveMediaImage';

import { EVENT_MEDIA_CAMERA_TYPE } from '../dashboard/EventMedia/eventMediaConstants';
import Events from 'APP_ROOT/components/common/events';

class LiveMedia extends React.PureComponent {

    fullscreenElementRef = React.createRef();

    constructor(props) {

        super(props);
        this.state = {
            paused: false
        };
    }

    toggleCamera = (e) => {
        this.props.toggleCamera(this.props.cameraType);
    }

    onLiveStream = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
        return this.props.onLiveStream(this.props.cameraType);
    }

    render() {

        var previewImageData;
        var date;

        if (this.props.cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
            previewImageData = this.props.roadCamera.image;
            date = this.props.roadCamera.date;
        } else {
            previewImageData = this.props.cabinCamera.image;
            date = this.props.cabinCamera.date;
        }

        return (
            <div className="event-media-wrapper-16-9-aspect-ratio" ref={this.fullscreenElementRef}>
                <div className="event-media-wrapper">
                    <LiveMediaImage
                        previewImageData={previewImageData}
                        date={date}
                    />
                </div>
            </div>
        )
    }
}

LiveMedia.propTypes = {
    shouldShowAlternateCameraType: PropTypes.bool,
    roadCamera: PropTypes.shape({
        image: PropTypes.oneOfType([
            PropTypes.object, // image data src
            PropTypes.string  // or image url src
        ]),
        date: PropTypes.instanceOf(Date)
    }),
    cabinCamera: PropTypes.shape({
        image: PropTypes.oneOfType([
            PropTypes.object, // image data src
            PropTypes.string  // or image url src
        ]),
        date: PropTypes.instanceOf(Date)
    }),
    unplugged: PropTypes.bool,
    offline: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    // determine the current default/selected camera type
    let cameraType = state.scenes.dashboard.EventMedia.cameraType;
    // if this component should show the alternate camera, change this cameraType to show alternate
    if (ownProps.shouldShowAlternateCameraType) {
        if (cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
            cameraType = EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN;
        } else {
            cameraType = EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD;
        }
    }
    return {
        cameraType: cameraType
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        toggleCamera: (cameraTypeForComponent) => {
            let currentCamera = cameraTypeForComponent;
            // check if component is showing the alternate camera
            // ASSUMPTION: the toggle request should always be for the non-alternate camera type
            if (ownProps.shouldShowAlternateCameraType) {
                if (currentCamera === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
                    currentCamera = EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN;
                } else {
                    currentCamera = EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD;
                }
            }
            dispatch(setCamera(currentCamera === CameraType.CAMERA_ROAD ? CameraType.CAMERA_CABIN : CameraType.CAMERA_ROAD));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveMedia);